/** Native list design defaults. These values are the established member-style list contract. */
export const spacing = { xs: 4, sm: 8, md: 12, lg: 16, xl: 24, elementGap: 12 } as const;
export const borderRadius = { control: 4 } as const;
export const cardDefaults = {
  listCardBodyStyle: { padding: spacing.xl },
  listCardBodyStyleCompact: { padding: spacing.md },
  listCardHeaderMarginBottom: 12,
} as const;
export const layoutDefaults = { pageHeaderMarginBottom: 16 } as const;
const pageTitleFontSize = 20;
const pageTitleLineHeight = 1.4;
const sectionTitleFontSize = 16;
const sectionTitleLineHeight = 1.5;
export const typography = {
  fontSize: { body: 14, secondary: 12, badge: 10 },
  title: {
    level4: { fontSize: pageTitleFontSize, lineHeight: pageTitleLineHeight, fontWeight: 600 },
    level5: { fontSize: sectionTitleFontSize, lineHeight: sectionTitleLineHeight, fontWeight: 600 },
  },
} as const;
/** Card density changes spacing, while the native title hierarchy stays the same. Opt-in theme tokens. */
export const memberCardTypography = {
  headerFontSize: typography.title.level5.fontSize,
  headerFontSizeSM: typography.title.level5.fontSize,
} as const;
export function cssSpacing(...values: Array<number | "auto">): string {
  return values.map(value => typeof value === "number" ? `${value}px` : value).join(" ");
}
